import { Grid } from "@mui/material";
import React, { useCallback, useEffect, useMemo, useRef } from "react";

interface IFormWithHostPost {
  targetId: string;
  formId: string;
  onFormSubmitSuccess?: () => void;
  onFormSubmitError?: () => void;
}
function FormWithHostPost(props: IFormWithHostPost) {
  const { targetId, formId, onFormSubmitError, onFormSubmitSuccess } = props;
  const hasFormRenderedRef = useRef(false);

  const config = useMemo(
    () => ({
      region: "na1",
      portalId: "24346264",
      formId: formId,
      target: `#${targetId}`,
      onFormSubmit: function (_form: any) {
        // if (onFormSubmitSuccess) {
        //   setTimeout(() => {
        //     onFormSubmitSuccess();
        //   }, 1000);
        // }
      },
      onFormError: function (_errors: any) {
        if (onFormSubmitError) {
          onFormSubmitError();
        }
      },
      onFormSubmitted: function (_form: any) {
        if (onFormSubmitSuccess) {
          onFormSubmitSuccess();
        }
      },
    }),
    [formId, targetId, onFormSubmitError, onFormSubmitSuccess]
  );

  const resetTarget = useCallback(() => {
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.innerHTML = "";
    }
  }, [targetId]);

  const createForm = useCallback(() => {
    if (typeof window === "undefined") {
      return;
    }

    if (hasFormRenderedRef.current) {
      return;
    }

    const targetElement = document.getElementById(targetId);
    // Ensure the container exists before we try to clear or render the form.
    if (!targetElement) {
      return;
    }

    resetTarget();

    // @ts-ignore
    const hbsptForms = window.hbspt?.forms;

    if (hbsptForms) {
      hbsptForms.create(config);
      hasFormRenderedRef.current = true;
    }
  }, [config, resetTarget, targetId]);

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    hasFormRenderedRef.current = false;

    const scriptSrc = "https://js.hsforms.net/forms/embed/v2.js";
    const scriptId = `hs-form-script-${formId}`;

    const handleScriptLoad = () => {
      createForm();
    };

    const markLoadedAndCreate = () => {
      const scriptElement = document.getElementById(scriptId);
      if (scriptElement) {
        scriptElement.setAttribute("data-loaded", "true");
      }
      handleScriptLoad();
    };

    const existingScript = document.getElementById(scriptId) as
      | HTMLScriptElement
      | null;

    if (existingScript) {
      if (existingScript.getAttribute("data-loaded") === "true") {
        createForm();
      } else {
        existingScript.addEventListener("load", markLoadedAndCreate);
      }
    } else {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = scriptSrc;
      script.async = true;
      script.addEventListener("load", markLoadedAndCreate);
      document.body.appendChild(script);
    }

    return () => {
      const script = document.getElementById(scriptId);
      if (script) {
        script.removeEventListener("load", markLoadedAndCreate);
      }

      resetTarget();
      hasFormRenderedRef.current = false;
    };
  }, [createForm, formId, resetTarget]);

  return (
    <Grid container item xs={12}>
      <Grid item xs={12} id={props.targetId} />
    </Grid>
  );
}

export default FormWithHostPost;
// FormWithHostPost;
